import { render, staticRenderFns } from "./view.html?vue&type=template&id=0a843e50&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=0a843e50&lang=less&scoped=true&"
import style1 from "./style_mobile.less?vue&type=style&index=1&id=0a843e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a843e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a843e50')) {
      api.createRecord('0a843e50', component.options)
    } else {
      api.reload('0a843e50', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=0a843e50&scoped=true&", function () {
      api.rerender('0a843e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/crash/components/ui-game-sidebar/index.vue"
export default component.exports